import React from 'react';
import { connect } from 'react-redux'
import { hashHistory } from 'react-router'
import {
    sendMessage,
    loadMessage,
    showMessagesAction,
    createNewMessage,
    selectATopic,
    updateGlobalNewMessageCount,
    changeToAbsolute
} from '../actions/messageActions';

import Paper from 'material-ui/Paper';
import '../index.css';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Message from '../Components/Messaging/View';
import HeaderSmall from '../Components/Header/HeaderSmall';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import Topics from '../Components/Messaging/Topics';
import Spinner from '../Components/Spinner';
import Send from 'material-ui/svg-icons/navigation/arrow-upward';
import Picture from 'material-ui/svg-icons/image/photo-camera';
import TextField from 'material-ui/TextField';
import { getToken } from '../utils/tokenUtil'
import { resourceApi } from '../utils/fetchUtil';
import { publicApi } from '../constants/config';
import Dialog from 'material-ui/Dialog';
import { grey400 } from 'material-ui/styles/colors';

class MessagePage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            replyMessage: "",
            afterHoursMessage: null,
            viewDoc: false,
            open: false,
        }
    }

    componentDidMount() {

        //window.onresize = this.resize;
  
        this.props.updateGlobalNewMessageCount();

        if (this.props.params.id === "0") {
            this.props.createNewMessage();
        }
    }

    resize = () => {
        var h = document.querySelector("#height");
        var w = document.querySelector("#width");
        h.textContent = window.innerHeight;
        w.textContent = window.innerWidth;
        alert('done')
    }

    sendMessage = () => {
        if (this.state.replyMessage !== "") {
            this.props.sendMessage(this.state.replyMessage);
            this.setState({ replyMessage: '' });
        }
    }

    newMessage = () => {
        this.props.createNewMessage();
    }

    handleReplyMessageChange = (event, value) => {
        this.setState({ replyMessage: value });
    }

    returnFunction = () => {
        //if SystemMessageLogID = 0 && SystemMessageTopicID != 0 
        //they are creating a new message and should go back to the topics if go back is clicked
        if(this.props.message && this.props.message.SystemMessageLogID === 0 && this.props.message.SystemMessageTopicID != 0){
            this.newMessage();
        }
        else {
            hashHistory.goBack();
        }
    }

    win = (r) => {
        console.log("Code = " + r.responseCode);
        console.log("Response = " + r.response);
        console.log("Sent = " + r.bytesSent);

        this.props.sendMessage("Uploaded a document", r.response);

        this.setState({ fetching: false });
        // will do a get for the last photo uploaded to the reply. 
    }

    fail = (error) => {
        this.setState({ fetching: false });

        //alert("Unable to upload the document.");
        console.log("upload error source " + error.source);
        console.log("upload error target " + error.target);
    }

    uploadDocumentBrowser = (event) => {

        const file = event.target.files[0];

        let data = new FormData();
        data.append('file', file);
        data.append('name', "test");

        console.log(data);

        var self = this;

        this.setState({ fetching: true });

        let config = {
            method: 'post',
            url: `member/document/upload`,
            data: data
        };

        resourceApi(config)
            .then(function (response) {
                console.log(response);

                //self.setState({ providers: response.data });
                self.props.sendMessage("Uploaded a document", response.data);
                self.setState({ fetching: false, open: false });
            })
            .catch(function (error) {
                console.log(error);
                self.setState({ fetching: false });
            });
    }

    takePhoto = () => {

        var self = this;


        if ((navigator) && (navigator.camera)) {
            self.setState({ takePicture: true });

            navigator.camera.getPicture(
                function (imageData) {

                    self.uploadDocumentPhone(imageData);


                },
                function () {
                    //alert(error);
                },
                {}
            );
        }
        else {
            this.setState({ open: true });
        }
    }

    uploadDocumentPhone = (fileURL) => {

        this.setState({ fetching: true });

        var uri = encodeURI(publicApi + "member/document/upload");

        var options = new window.FileUploadOptions();
        options.fileKey = "file";
        options.fileName = fileURL.substr(fileURL.lastIndexOf('/') + 1);
        options.mimeType = "image/jpeg"; //png
        options.targetHeight = 1200;
        options.targetWidth = 1200;
        //options.correctOrientation = true;

        var headers = { 'Authorization': 'Bearer ' + getToken() };

        options.headers = headers;

        var ft = new window.FileTransfer();
        ft.onprogress = function (progressEvent) {

            if (progressEvent.lengthComputable) {

                //loadingStatus.setPercentage(progressEvent.loaded / progressEvent.total);
            } else {

                //loadingStatus.increment();
            }
        };
        ft.upload(fileURL, uri, this.win, this.fail, options);
    }

    handleClose = () => {
        this.setState({ open: false, viewDoc: false });
    }

    viewDocument = (id) => {

        var self = this;

        this.setState({ fetching: true });

        let config = {
            method: 'get',
            url: `member/document/${id}`
        };

        resourceApi(config)
            .then(function (response) {
                console.log(response);

                self.setState({ doc: response.data, viewDoc: true, fetching: false });
            })
            .catch(function (error) {
                console.log(error);
                self.setState({ fetching: false });
            });


    }

    newMessage = () => {
        this.props.createNewMessage();
        this.props.router.push(`/message/0/view`);
      }

    render() {

        const actions = [
            <FlatButton
                label="Close"
                primary={true}
                onClick={this.handleClose}
            />
        ];

        let showStartNewConversation = false;

        function allowReply(msg){

            if (msg.IsArchived === true) {
                showStartNewConversation = true;
                return false;
            }
            else if (msg.AllowReplies === false && msg.SystemMessageTypeID === 1) {
                showStartNewConversation = false;
                return false;
            }
            else {
                return true;
            }
        }


        return (
            <div>
                <HeaderSmall title="View Message" goBackFunction={this.returnFunction} />
                {!this.state.fetching && (
                    <div>
                        {this.props.message && (
                            <div>
                            <br />
                            <br />
                            <br />
                            <br />
                            </div>
                        )}
                        <span id="height"></span>
                                    <span id="width"></span>

                        {!this.props.message && (
                            <Topics selectTopic={this.props.selectATopic} />
                        )}

                        {!this.state.viewDoc && this.props.message && (
                            <div id="chatContainer" >
                                <div id="messageView" style={{overflowY:'scroll', padding:'0 15px 0 15px'}} >
                                    <Message message={this.props.message} viewDocument={this.viewDocument} />
                                    
                                </div>
                                {!allowReply(this.props.message) && this.props.member.IsTwoWayMessagingActive && (
                                    <div className="is-sticky" style={{ position:'fixed', width: '100%', bottom: 5 }}>
                                        {showStartNewConversation && (
                                            <Paper style={{ width: '100%', padding: 5, margin: '0 auto' }}>
                                                <div style={{ textAlign: 'center' }}>
                                                    <p style={{ 'font-family': 'TruenoLight', padding: 10, margin: 0 }}>
                                                        This conversation has ended. Click below to begin a new conversation.
                                                    </p>
                                                    <RaisedButton onClick={this.newMessage} fullWidth={true} primary={'true'} label={'Begin a New Conversation'} />
                                                </div>
                                            </Paper>
                                        )}
                                    </div>
                                )}
                                {allowReply(this.props.message) && this.props.member.IsTwoWayMessagingActive && (
                                    <div id="messageInput" className="is-sticky" style={{ position: 'fixed', bottom: 0 }}>
                                        <Paper style={{ padding: 5 }}>
                                            <div>
                                                <table>
                                                    <tbody>
                                                    <tr>
                                                        {this.props.member.IsDocumentUploadAvailable && (
                                                            <td style={{ width: 30, paddingTop: 5 }}>
                                                                <Picture onClick={this.takePhoto} color={grey400} />
                                                            </td>
                                                        )}
                                                        <td style={{ width: (this.props.member.IsDocumentUploadAvailable ? '84%' : '90%') }}>
                                                            <TextField
                                                                multiLine={true}
                                                                fullWidth={true}
                                                                hintText="Enter your message here"
                                                                onChange={this.handleReplyMessageChange}
                                                                value={this.state.replyMessage}
                                                                //ontouchstart={scrollDown}
                                                                onFocus={this.props.changeToAbsolute}
                                                            />
                                                        </td>
                                                        <td>
                                                            <FloatingActionButton
                                                                mini={true}

                                                                onClick={this.sendMessage}
                                                            >
                                                                <Send />
                                                            </FloatingActionButton>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </Paper>
                                    </div>
                                )}

                                <div style={{height:350}}>&nbsp;</div>

                            </div>
                        )}

                        {this.state.viewDoc && (
                            <div style={{ textAlign: 'center' }}>
                                <FlatButton label="Close" primary={true} onClick={this.handleClose} />
                                <br />
                                {this.state.doc && (
                                    <img src={this.state.doc.Url} style={{ maxWidth: '90%' }} />
                                )}
                            </div>
                        )}
                    </div>
                )}

                {this.state.fetching && (
                    <Spinner />
                )}
                <Dialog
                    actions={actions}
                    modal={false}
                    open={this.state.open}
                    onRequestClose={this.handleClose} >

                    <input type="file" onChange={this.uploadDocumentBrowser} />
                </Dialog>
            </div>
        );
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        sendMessage: (message, documentId) => {
            dispatch(sendMessage(message, documentId));
        },
        loadMessage: (id) => {
            dispatch(loadMessage(id));
        },
        showMessages: () => {
            dispatch(showMessagesAction());
        },
        createNewMessage: () => {
            dispatch(createNewMessage());
        },
        selectATopic: (id, text) => {
            dispatch(selectATopic(id, text));
        },
        updateGlobalNewMessageCount: () => {
            dispatch(updateGlobalNewMessageCount());
        },
        createNewMessage: () => {
            dispatch(createNewMessage());
        },
        changeToAbsolute: () => {
            dispatch(changeToAbsolute());
        }
    }
}

const mapStateToProps = (state) => ({
    member: state.thisApp.auth.member,
    messages: state.thisApp.messaging.messages,
    message: state.thisApp.messaging.message,
    showMessage: state.thisApp.messaging.showMessage,
    messageHeight: state.thisApp.messaging.minHeight,
    dimensions: state.thisApp.messaging.dimensions
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MessagePage)












// WEBPACK FOOTER //
// ./src/Pages/Message.js